if (document.querySelector(".collection-page")) {
  const collectionTabs = document.querySelector(".collection-page__ul"),
    collectionHandler = collectionTabs.querySelectorAll(".collection-page__li"),
    categories = document.querySelector(".collection-page__h3--collections"),
    fullCollections = document.querySelector(".collection-page__ul");

  categories.addEventListener("click", () => {
    fullCollections.classList.toggle("open");
  });
  collectionHandler.forEach((collection) => {
    const buttonMore = collection.querySelector(".collection-page__li--more"),
      subCollections = collection.querySelector(
        ".collection-page__sub-collection"
      );

    if (buttonMore && subCollections) {
      buttonMore.addEventListener("click", () => {
        if (subCollections.classList.toggle("open")) {
          buttonMore.style.rotate = "-45deg";
        } else {
          buttonMore.style.rotate = "0deg";
        }
      });
    }
  });
}
